import React from 'react';
import { useLocationStore } from '../stores/locationStore';
import { districts } from '@bid/bitd-data';
import type { District } from '@bid/shared-types';

export const DistrictSelector: React.FC = (): JSX.Element => {
  const { selectedDistrict, setDistrict } = useLocationStore();

  const containerStyle: React.CSSProperties = {
    marginBottom: '32px',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    color: '#d4af37',
    fontWeight: 600,
    fontSize: '14px',
    marginBottom: '12px',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  };

  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '12px',
  };

  const getButtonStyle = (isSelected: boolean): React.CSSProperties => ({
    padding: '16px',
    borderRadius: '8px',
    border: isSelected ? '2px solid #d4af37' : '1px solid rgba(212, 175, 55, 0.2)',
    backgroundColor: isSelected ? '#d4af37' : '#0f0f1e',
    color: isSelected ? '#0f0f1e' : '#e5e7eb',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textAlign: 'left' as const,
  });

  const districtNameStyle: React.CSSProperties = {
    fontWeight: 600,
    fontSize: '15px',
    marginBottom: '4px',
  };

  const districtMetaStyle: React.CSSProperties = {
    fontSize: '12px',
    opacity: 0.75,
  };

  const clearButtonStyle: React.CSSProperties = {
    marginTop: '12px',
    padding: '8px 16px',
    backgroundColor: 'transparent',
    border: '1px solid rgba(212, 175, 55, 0.2)',
    borderRadius: '6px',
    color: '#6b7280',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      <label style={labelStyle}>District (Optional)</label>
      <div style={gridStyle}>
        {districts.map(district => {
          const isSelected = selectedDistrict === district.name;
          return (
            <button
              key={district.name}
              onClick={() =>
                setDistrict(district.name === selectedDistrict ? null : (district.name as District))
              }
              style={getButtonStyle(isSelected)}
              onMouseEnter={e => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.5)';
                  e.currentTarget.style.backgroundColor = 'rgba(212, 175, 55, 0.05)';
                }
              }}
              onMouseLeave={e => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
                  e.currentTarget.style.backgroundColor = '#0f0f1e';
                }
              }}
            >
              <div style={districtNameStyle}>{district.name}</div>
              <div style={districtMetaStyle}>
                {district.wealth} • {district.security} security
              </div>
            </button>
          );
        })}
      </div>
      {selectedDistrict && (
        <button
          onClick={() => setDistrict(null)}
          style={clearButtonStyle}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = '#d4af37';
            e.currentTarget.style.color = '#d4af37';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
            e.currentTarget.style.color = '#6b7280';
          }}
        >
          Clear selection
        </button>
      )}
    </div>
  );
};
